<template>
  <div class="comment-content">
    <div v-for="item in comment_list"
         :key="item.id">
      <FlashbaseCommentContent :item="item.item"
                               :data="item.comment"
                               :is-order="false"
                               :is-custom="false"
                               :is-admin="false"
                               @append-show="append(item)"
                               @submit-reply="reply"
                               @edit="edit(item)">
        <template #appendComment>
          <FlashbaseCommentAppend :append-list="commentDate(item.comment)"
                                  :created-at="item.comment[0].createdAt"></FlashbaseCommentAppend>
          <FlashbaseCommentReply :is-detail="false"
                                 :is-custom="false"
                                 :is-admin="false"
                                 :comment-id="item.comment[0].id"
                                 :user-id="item.comment[0].user.id"
                                 :append-list="item.comment[0].commentReplys"
                                 :created-at="item.comment[0].createdAt"
                                 @submit-reply="submitReply"></FlashbaseCommentReply>
        </template>
      </FlashbaseCommentContent>

      <!-- <comment-reply :a></comment-reply> -->
    </div>
    <div class="page-content">
      <APagination v-model:current="paginationCurrent"
                   v-model:pageSize="paginationSize"
                   :page-size-options=paginationSizeOptions
                   :show-size-changer="true"
                   :total="paginationTotal"
                   @change="changePagination" />
    </div>
    <a-modal v-model:visible="is_append"
             :title="$t('Comment.Comment.append')"
             width="50%"
             :footer="null">
      <div class="comment-item">
        <FlashbaseCommentItem :item="append_data"
                              :is-edit="false"
                              :is-divider="false"
                              :is-append="true"
                              @create-success="createSuccess"></FlashbaseCommentItem>
      </div>
    </a-modal>
    <a-modal v-model:visible="is_edit"
             :title="$t('Comment.Comment.edit')"
             width="50%"
             :footer="null">
      <div>
        <FlashbaseCommentItem :item="edit_data"
                              :is-edit="true"
                              :is-divider="false"
                              :is-append="false"
                              @create-success="createSuccess"></FlashbaseCommentItem>
      </div>
    </a-modal>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue"
import { APagination } from '@iota-cn/ui-components'
import { sortBy } from "../../custom-spus/utils"
import { fetchComment } from "../api/index"

// const order_detail = ref()
const comment_list = ref()
onMounted(async () => {
  await init()
})
const paginationTotal = ref(0)
const paginationSize = ref(5)
const paginationSizeOptions = ref([5, 10, 20, 50])
const paginationCurrent = ref(1)
const offset = ref<number>(0)
const init = async () => {
  const data = {
    limit: paginationSize.value,
    offset: offset.value
  }
  await fetchComment(data).then((res: any) => {
    paginationTotal.value = res.count
    // order_detail.value = res
    comment_list.value = []
    res.data.forEach((r: any) => {
      comment_list.value.push({
        comment: [r],
        item: r.item,
        user: r.user
      })
    })
  })
  is_append.value = false
  is_edit.value = false
}

// 分页
const changePagination = async (page: number, pageSize: number) => {
  paginationSize.value = pageSize
  paginationCurrent.value = page
  offset.value = (page - 1) * pageSize
  await init()
}
const createSuccess = async () => {
  await init()
}
const reply = async () => {
  await init()
}
const submitReply = async () => {
  await init()
}
const is_append = ref<boolean>(false)
const append_data = ref<any>()
const append = (value: any) => {
  is_append.value = true
  append_data.value = {
    comments: value.comment,
    ...value.item
  }
}
const edit_data = ref<any>()
const is_edit = ref<boolean>(false)
const edit = (value: any) => {
  is_edit.value = true
  edit_data.value = {
    comments: value.comment,
    ...value.item
  }
}
const commentDate = (data: any) => {
  // eslint-disable-next-line vue/no-mutating-props, vue/no-side-effects-in-computed-properties
  return data[0].children ? data[0].children.sort(sortBy('createdAt', true)) : []
}
</script>
<style scoped lang="less">
.comment-content {
  padding: 20px;
  height: 100%;
  overflow: scroll;

  .page-content {
    float: right;
  }

  .comment-item {
    margin-top: 20px;
    padding: 20px;
    background: #F6F6F6;
  }
}
</style>
